<template>
  <div class="sidebar-details">
    <div class="sidebar-details-header">
      <div class="sidebar-details-close" v-on:click="$store.dispatch('backDetails')">
        <i class="far fa-arrow-alt-circle-left"></i>
      </div>
    </div>
    <div class="sidebar-details-body">
      <Loading/>
    </div>
  </div>
</template>

<script>
import Loading from "../../Loading";

export default {
  components: {
    Loading
  }
};
</script>
